module.exports = __webpack_public_path__ + "static/media/REDESIGN WITH US.42896a9b.jpg";